<template>
  <div class="container-full" >
    <div class=" banner-div"  v-if="articleDetail.blogPic">
      <div class="banner-title">
        <div>{{articleDetail.title}}</div>
      </div>
      <img class="banner-img" :src="articleDetail.blogPic"/>
    </div>

  </div>

</template>
<script>
import api from "../api/api";

export default {
  name: 'topBanner',
  components: {},
  //menu  主要需要typeId
  props: {
    typeId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      tags: [],
      activeName: '',
      articleDetail: {}
    }
  },
  watch: {
    typeId: {
      handler(newVal) {
        this.getData()
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.articleDetail = {}
      api.getAriticle({language: this.$store.state.lang, typeId: this.typeId}).then(res => {
        let list = res.data.data
        if (list && list.length > 0) {
          this.articleDetail = list[0]
        }
      })
    }
  }
}
</script>
<style scoped>
.banner-div{
  height: calc(100vh - 60px);
  width: 100%;
  overflow: hidden;
  position: relative;
}
.banner-img{
  width: 100%;
  height: 100%;

}
.banner-title{
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100vh - 60px);
  text-align: center;
  font-size: 60px;
  background: rgba(0,0,0,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 997px) {
  .banner-div {
    height: 300px;
  }

  .banner-title {
    height: 300px;
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topBanner.vue